import React from 'react';
import { ConsentFormViewRendererProps } from '../types';
import Desktop from './Desktop';

function ViewRenderer(props: ConsentFormViewRendererProps) {
  return <Desktop {...props} />;
}

export default ViewRenderer;
